export default __webpack_public_path__ + "static/media/silver-card.3dd97a12.svg";